import "core-js/modules/es6.object.assign";
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import { d as _inheritsLoose, e as _defineProperty, f as _assertThisInitialized, a as _extends } from './chunk-79dadc73.js';
import { createElement, Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { a as as } from './as-39ca1b5e.js';
import '@emotion/is-prop-valid';
import 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import './Box.js';
import { findDOMNode } from 'react-dom';
import './chunk-11bd1c20.js';
import './Hidden.js';
import 'constate';
import './chunk-27cf4a5a.js';
import './chunk-23007274.js';
import './chunk-c3683479.js';
import 'popper.js';
import { a as PopoverArrow } from './chunk-48ece6bc.js';
import Popover from './Popover.js';

var TooltipComponent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TooltipComponent, _React$Component);

  function TooltipComponent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      visible: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isControlled", function () {
      return typeof _this.props.visible !== "undefined";
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "show", function () {
      return _this.setState({
        visible: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hide", function () {
      return _this.setState({
        visible: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTooltip", function () {
      return findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
    });

    return _this;
  }

  var _proto = TooltipComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$getTooltip = this.getTooltip(),
        parentNode = _this$getTooltip.parentNode;

    if (parentNode && !this.isControlled()) {
      parentNode.addEventListener("mouseenter", this.show);
      parentNode.addEventListener("focus", this.show);
      parentNode.addEventListener("mouseleave", this.hide);
      parentNode.addEventListener("blur", this.hide);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$getTooltip2 = this.getTooltip(),
        parentNode = _this$getTooltip2.parentNode;

    if (parentNode) {
      parentNode.removeEventListener("mouseenter", this.show);
      parentNode.removeEventListener("focus", this.show);
      parentNode.removeEventListener("mouseleave", this.hide);
      parentNode.removeEventListener("blur", this.hide);
    }
  };

  _proto.render = function render() {
    var _ref = this.isControlled() ? this.props : this.state,
        visible = _ref.visible;

    return createElement(Popover, _extends({}, this.props, {
      visible: visible
    }));
  };

  return TooltipComponent;
}(Component);

hoistNonReactStatics(TooltipComponent, Popover);
var Tooltip = styled(TooltipComponent).withConfig({
  displayName: "Tooltip",
  componentId: "sc-15idyy7-0"
})(["", ";"], theme("Tooltip"));
Tooltip.defaultProps = {
  role: "tooltip",
  placement: "top",
  opaque: true,
  palette: "grayscale"
};
var Tooltip$1 = as("div")(Tooltip);
var TooltipArrow = styled(PopoverArrow).withConfig({
  displayName: "TooltipArrow",
  componentId: "rwnerm-0"
})(["", ";"], theme("TooltipArrow"));
TooltipArrow.defaultProps = {
  palette: "grayscale"
};
var TooltipArrow$1 = as("div")(TooltipArrow);
var index = Object.assign(Tooltip$1, {
  Arrow: TooltipArrow$1
});
export default index;